var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"home_c"},[_vm._v(" "+_vm._s(_vm.currentTime)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }